"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const schema_1 = require("lincd-schema/lib/ontologies/schema");
const Person_1 = require("profile-pics/lib/shapes/Person");
const models_1 = require("lincd/lib/models");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const profile_plus_1 = require("../ontologies/profile-plus");
const package_1 = require("../package");
let Person = class Person extends Person_1.Person {
    get smokingHabit() {
        //["Smoker", "Social smoker", "Smoker when drinking", "Trying to quit", "Non-smoker"]
        return this.getValue(profile_plus_1.profilePlus.smokingHabit);
    }
    set smokingHabit(val) {
        this.overwrite(profile_plus_1.profilePlus.smokingHabit, new models_1.Literal(val));
    }
    get drinkFrequency() {
        return this.getValue(profile_plus_1.profilePlus.drinkFrequency);
    }
    set drinkFrequency(val) {
        this.overwrite(profile_plus_1.profilePlus.drinkFrequency, new models_1.Literal(val));
    }
    get fourTwentyFriendly() {
        return this.getValue(profile_plus_1.profilePlus.fourTwentyFriendly);
    }
    set fourTwentyFriendly(val) {
        this.overwrite(profile_plus_1.profilePlus.fourTwentyFriendly, new models_1.Literal(val));
    }
    get workoutFrequency() {
        return this.getValue(profile_plus_1.profilePlus.workoutFrequency);
    }
    set workoutFrequency(val) {
        this.overwrite(profile_plus_1.profilePlus.workoutFrequency, new models_1.Literal(val));
    }
    get workoutFrequencyNumber() {
        //["Everyday", "Often", "Sometimes", "Never"]
        switch (this.workoutFrequency) {
            case 'Everyday':
                return 3;
                break;
            case 'Often':
                return 2;
                break;
            case 'Sometimes':
                return 1;
                break;
            case 'Never':
                return 0;
                break;
        }
        return -1;
    }
    get passions() {
        return this.getAll(profile_plus_1.profilePlus.hasPassion);
    }
    get beliefs() {
        return this.getAll(profile_plus_1.profilePlus.hasBelief);
    }
    get systemIdeologies() {
        return this.getAll(profile_plus_1.profilePlus.hasSystemIdeology);
    }
    get coreValues() {
        return this.getAll(profile_plus_1.profilePlus.hasCoreValue);
    }
    get spiritualPractices() {
        return this.getAll(profile_plus_1.profilePlus.hasSpiritualPractice);
    }
    get sacredTexts() {
        return this.getAll(profile_plus_1.profilePlus.hasSacredText);
    }
    get mayanAstrology() {
        return this.getValue(profile_plus_1.profilePlus.hasMayanAstrology);
    }
    set mayanAstrology(val) {
        this.overwrite(profile_plus_1.profilePlus.hasMayanAstrology, new models_1.Literal(val));
    }
    get chineseZodiac() {
        return this.getValue(profile_plus_1.profilePlus.hasChineseZodiac);
    }
    set chineseZodiac(val) {
        this.overwrite(profile_plus_1.profilePlus.hasChineseZodiac, new models_1.Literal(val));
    }
    get myersBriggsPersonalityType() {
        return this.getValue(profile_plus_1.profilePlus.hasPersonalityType);
    }
    set myersBriggsPersonalityType(val) {
        this.overwrite(profile_plus_1.profilePlus.hasPersonalityType, new models_1.Literal(val));
    }
    get loveLanguage1() {
        return this.getValue(profile_plus_1.profilePlus.hasLoveLanguage1);
    }
    set loveLanguage1(val) {
        this.overwrite(profile_plus_1.profilePlus.hasLoveLanguage1, new models_1.Literal(val));
    }
    get loveLanguage2() {
        return this.getValue(profile_plus_1.profilePlus.hasLoveLanguage2);
    }
    set loveLanguage2(val) {
        this.overwrite(profile_plus_1.profilePlus.hasLoveLanguage2, new models_1.Literal(val));
    }
    get loveLanguage3() {
        return this.getValue(profile_plus_1.profilePlus.hasLoveLanguage3);
    }
    set loveLanguage3(val) {
        this.overwrite(profile_plus_1.profilePlus.hasLoveLanguage3, new models_1.Literal(val));
    }
    get loveLanguage4() {
        return this.getValue(profile_plus_1.profilePlus.hasLoveLanguage4);
    }
    set loveLanguage4(val) {
        this.overwrite(profile_plus_1.profilePlus.hasLoveLanguage4, new models_1.Literal(val));
    }
    get loveLanguage5() {
        return this.getValue(profile_plus_1.profilePlus.hasLoveLanguage5);
    }
    set loveLanguage5(val) {
        this.overwrite(profile_plus_1.profilePlus.hasLoveLanguage5, new models_1.Literal(val));
    }
    get spiritualJourney() {
        return this.getValue(profile_plus_1.profilePlus.hasSpiritualJourney);
    }
    set spiritualJourney(val) {
        this.overwrite(profile_plus_1.profilePlus.hasSpiritualJourney, new models_1.Literal(val));
    }
};
exports.Person = Person;
Person.targetClass = schema_1.schema.Person;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.smokingHabit,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "smokingHabit", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.drinkFrequency,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "drinkFrequency", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.fourTwentyFriendly,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "fourTwentyFriendly", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.workoutFrequency,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "workoutFrequency", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasPassion,
        required: false,
        maxCount: 7,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "passions", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasBelief,
        required: false,
        maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "beliefs", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasSystemIdeology,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "systemIdeologies", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasCoreValue,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "coreValues", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasSpiritualPractice,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "spiritualPractices", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasSacredText,
        required: false,
        // maxCount: 5,
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Person.prototype, "sacredTexts", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasMayanAstrology,
        required: false,
        // maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "mayanAstrology", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasChineseZodiac,
        required: false,
        // maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "chineseZodiac", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasPersonalityType,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "myersBriggsPersonalityType", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasLoveLanguage1,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage1", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasLoveLanguage2,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage2", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasLoveLanguage3,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage3", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasLoveLanguage4,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage4", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasLoveLanguage5,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "loveLanguage5", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: profile_plus_1.profilePlus.hasSpiritualJourney,
        required: false,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Person.prototype, "spiritualJourney", null);
exports.Person = Person = __decorate([
    package_1.linkedShape
], Person);
//# sourceMappingURL=Person.js.map